export enum CompanyType {
    LEGAL_PERSON = "Юридическое лицо",
    INDIVIDUAL = "Физическое лицо"
}
